import axios from 'axios'
const USERS_API_URL = process.env.REACT_APP_USERS_API_URL



const getAllUsers = async () => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  const response = await axios.get(`${USERS_API_URL + 'users'}`, config)
  return response
}
const getUserById = async (id: any) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  const response = await axios.get(`${USERS_API_URL + `users/${id}`}`, config)
  return response
}

const usersService = {
  getAllUsers,
  getUserById
}

export default usersService